import { WizardDataStatusInterface } from 'src/types/WizardDataStatusInterface'
import { COLORS, WIZARD_STATUS } from './constant'

export const getWizardColorByStatusFn = (type: string): string | undefined => {
  switch (type) {
    case WIZARD_STATUS.success:
      return COLORS.success
    case WIZARD_STATUS.in_progress:
      return COLORS.info
    case WIZARD_STATUS.pending:
      return COLORS.warning
    case WIZARD_STATUS.key_values_notification:
      return COLORS.warning
    case WIZARD_STATUS.error:
      return COLORS.error
    case WIZARD_STATUS.in_maintenance:
      return COLORS.in_maintenance
    case WIZARD_STATUS.zero_revenue:
      return COLORS.zero_revenue
    default:
      return undefined
  }
}

export const getWizardStatusPlatformsFn = (dashboard: WizardDataStatusInterface) => {
  const { status, platforms, zero_revenue, type } = dashboard

  const isOk = type === 'ok'

  const isWithZeroRevenue = Boolean(isOk && Object.keys(zero_revenue).length)

  let statusPlatforms: Array<{ platforms: string; message?: string }>
  if (isWithZeroRevenue) {
    const zeroRevenueKeys = Object.keys(zero_revenue)
    statusPlatforms = zeroRevenueKeys.map(platform => ({
      platforms: `${platform.replace(/_[0-9]+/i, '')} - ${zero_revenue[platform]}`,
    }))
  } else if (platforms) {
    const platformStatus = Array.isArray(platforms) ? platforms : [platforms]
    statusPlatforms = platformStatus
  } else {
    statusPlatforms = status || []
  }

  return statusPlatforms
}
